import React, { useEffect, useState } from "react";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import ModalHeader from "../../modals/modalHeader";
import { STRING_NOT_NULL_HELPER } from "../../../common/helpersTxt";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { validateString } from "../../../common/validators";
import { StyledModalRoot } from "../../styled/modal";

export default function CreateOrEditDeliveryOperatorModal({
  operator,
  show,
  closeModal,
  createOperator,
  editOperator,
}) {
  const [firstName, setFirstName] = useState(
    operator ? operator.first_name : null
  );
  const [isNameValid, setIsNameValid] = useState(false);
  const [lastName, setLastName] = useState(
    operator ? operator.last_name : null
  );
  const [isLastNameValid, setIsLastNameValid] = useState(false);
  const [username, setUsername] = useState(operator ? operator.username : null);
  const [isUsernameValid, setIsUsernameValid] = useState(false);
  const [password, setPassword] = useState(null);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (operator) {
      setIsEditing(true);
    }
  }, []);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value.toLowerCase());
  };

  const handleSubmit = () => {
    setSubmitted(true);

    const isValid =
      validateString(firstName) &&
      validateString(lastName) &&
      validateString(username) &&
      validateString(password);

    setIsNameValid(validateString(firstName));
    setIsLastNameValid(validateString(lastName));
    setIsUsernameValid(validateString(username));
    setIsPasswordValid(validateString(password));

    if (!isValid) {
      return;
    }

    const operatorObj = {
      username: username,
      first_name: firstName,
      last_name: lastName,
      password: password,
    };

    if (isEditing) {
      editOperator(operatorObj);
    } else {
      createOperator(operatorObj);
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        zIndex: 5000,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <StyledModalRoot width={600}>
          <ModalHeader
            label={operator ? "Editar Operador" : "Novo Operador"}
            margin={0}
            onClose={closeModal}
          />
          <Box
            sx={{
              padding: 6,
            }}
          >
            <TextField
              size="small"
              variant="outlined"
              id="new_operator_name"
              name="operator_name"
              label="Primeiro Nome"
              fullWidth
              required
              value={firstName}
              onChange={(event) => {
                setFirstName(event.target.value);
              }}
              error={!isNameValid && submitted}
              helperText={
                !isNameValid && submitted ? STRING_NOT_NULL_HELPER : ""
              }
              sx={{ mb: 2 }}
            />

            <TextField
              size="small"
              variant="outlined"
              id="new_operator_last_name"
              name="operator_last_name"
              label="Sobrenome"
              fullWidth
              required
              value={lastName}
              onChange={(event) => {
                setLastName(event.target.value);
              }}
              error={!isLastNameValid && submitted}
              helperText={
                !isLastNameValid && submitted ? STRING_NOT_NULL_HELPER : ""
              }
              sx={{ mb: 2 }}
            />

            <TextField
              size="small"
              variant="outlined"
              id="new_operator_username"
              name="new_operator_username"
              label="Usuário"
              fullWidth
              required
              value={username}
              onChange={handleUsernameChange}
              error={!isUsernameValid && submitted}
              helperText={
                !isUsernameValid && submitted ? STRING_NOT_NULL_HELPER : ""
              }
              inputProps={{
                autocomplete: "new-operator-username",
                form: {
                  autocomplete: "off",
                },
              }}
              sx={{ mb: 2 }}
            />

            <TextField
              required
              fullWidth
              name="new-operator-password"
              label="Senha"
              type="password"
              id="new-operator-password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              error={!isPasswordValid && submitted}
              helperText={
                !isPasswordValid && submitted ? STRING_NOT_NULL_HELPER : ""
              }
              inputProps={{
                autocomplete: "new-operator-password",
                form: {
                  autocomplete: "off",
                },
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              sx={{ mt: 4 }}
            >
              {isEditing ? "Atualizar" : "Cadastrar"}
            </Button>
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
}
